import { capitalize, debounce, forEach, get, find, result } from 'lodash';
import { PaymentCalculatorFactory, Formatter } from '@dealersites/dealersite-js-core';

import DSPFilter from './DSPFilter';
import { getParametersFromUrl, isNumeric } from './Filters/helpers';
import { updateBuildAndPriceBanner } from './components/build-and-price-banners';
import { inventoryLocalization } from './translations';
import { InventorySearchEvents } from './events';

import $ from 'jquery';
const parser = new DOMParser();

const mainContent = document.getElementById('main');
const dspFilters = mainContent ? mainContent.querySelector('#dsp-filters') : null;

if (mainContent && dspFilters) {
  const inventory = JSON.parse(dspFilters.getAttribute('data-inventory'));

  //Inventory selected with custom filters
  const selected = JSON.parse(dspFilters.getAttribute('data-selected'));
  const isDynamic = dspFilters.getAttribute('data-dynamic') === 'true';
  const sortBy = mainContent.querySelector('#js-sort-select');
  const titleSearch = mainContent.querySelector('#dsp_title');
  const vehicleContainer = mainContent.querySelector('#vehicle-results-container');
  const bnpBanner = mainContent.querySelector('.bnp-banner');
  const filters = dspFilters.querySelectorAll('.filter-container');
  const resetButton = mainContent.querySelector('#filter-reset');
  const submitButton = mainContent.querySelector('#filter-submit');
  const dspFilterList = [];

  let inventoryData, updateCallback;

  if (isDynamic && submitButton) {
    submitButton.parentElement.classList.add('d-none');
  }

  const searchKeys = [
    'address',
    'price_max',
    'price_min',
    'odometer_max',
    'odometer_min',
    'year_max',
    'year_min',
    'make',
    'model',
    'trim',
    'category',
    'transmission_type',
    'ext_colour',
    'engine',
    'engine_type',
    'fuel_type',
    'sort',
    'title',
  ];

  const drilldown_metadata = [
    'address',
    'model',
    'ext_colour',
    'engine',
    'trim',
    'engine_type',
    'fuel_type',
  ];

  const baseSearchParameters = {
    address: null,
    price_max: null,
    price_min: null,
    odometer_max: null,
    odometer_min: null,
    year_max: null,
    year_min: null,
    make: null,
    model: null,
    trim: null,
    category: null,
    transmission_type: null,
    ext_colour: null,
    engine_type: null,
    fuel_type: null,
    sort: null,
    title: null,
  };

  let searchParameters = { ...baseSearchParameters };

  function setMakesAndModelsLists(selectorElement) {
    if (['make', 'model', 'category'].includes(selectorElement.searchParameter)) {
        dspFilterList[selectorElement.searchParameter] = selectorElement.options;
    }
  }

  function updateUrl(parameters = searchParameters, keys = searchKeys) {
    const baseUrl = window.location.origin + window.location.pathname;
    const url = new URL(baseUrl);

    forEach(keys, (key) => {
      if (parameters[key]) {
        let parameterSlug = result(find(dspFilterList[key], function(obj) {
            return obj.id == parameters[key] || obj.slug == parameters[key];
        }), 'slug');

        if (parameterSlug) {
            url.searchParams.append(`dsp_${key}`, parameterSlug);
        } else {
            url.searchParams.append(`dsp_${key}`, parameters[key]);
        }
      }
    });

    const currentUrl = new URL(window.location);
    if (currentUrl.searchParams.has('lang')) {
      url.searchParams.set('lang', currentUrl.searchParams.get('lang'));
    }

    searchParameters = getParametersFromUrl(url);
    window.history.replaceState(null, null, url);
  }

  function updatePaymentCalculations() {
    $('.vehiclePayments .js-payment').each(function () {
      let $payment = $(this);
      let calculatorInputs = {
        price: $payment.data('price'),
        down: $payment.data('down'),
        term: $payment.data('term'),
        rate: $payment.data('rate'),
        tradein: $payment.data('tradein'),
        tax: 0,
      };

      const calculatorType = $payment.data('calculator');

      if (calculatorType === 'lease') {
        calculatorInputs.residual = $payment.data('residual');
      }

      if (['finance', 'lease'].includes(calculatorType)) {
        const calculator = PaymentCalculatorFactory.createCalculator(
          calculatorType,
          calculatorInputs
        );
        calculator.calculate();
        $payment.text(Formatter.price(calculator.payments.biweekly, 0));
      }
    });
  }

  async function getInventory(parameters = searchParameters, keys = searchKeys) {
    const baseUrl = window.location.origin + window.location.pathname;
    const $loader = $('#loader');

    $(document).trigger(InventorySearchEvents.PRE_FETCH);

    clearChildren(vehicleContainer);
    $loader.show();

    const url = new URL(baseUrl);

    keys.forEach((key) => {
      const value = get(parameters, key);
      if (value) {
        url.searchParams.append(`dsp_${key}`, value);
      }
    });

    const currentUrl = new URL(window.location);
    if (currentUrl.searchParams.has('lang')) {
      url.searchParams.set('lang', currentUrl.searchParams.get('lang'));
    }

    const res = await fetch(url);
    const html = await res.text();

    const doc = parser.parseFromString(html, 'text/html');
    const vehicleResults = doc.querySelector('#vehicle-results');
    inventoryData = JSON.parse(doc.querySelector('#dsp-filters').getAttribute('data-inventory'));

    $(document).trigger(InventorySearchEvents.POST_FETCH, [inventoryData]);

    $loader.hide();

    $(document).trigger(InventorySearchEvents.PRE_RENDER, [vehicleContainer]);
    clearChildren(vehicleContainer);
    vehicleContainer.appendChild(vehicleResults);
    $(document).trigger(InventorySearchEvents.POST_RENDER, [vehicleContainer]);

    updatePaymentCalculations();

    const sortSelect = document.getElementById('js-sort-select');
    if (sortSelect) {
      sortSelect.addEventListener(
        'change',
        debounce((event) => {
            searchParameters.sort = event.target.value;
            getInventory();
        }, 500)
      );
    }

    updateUrl(parameters, keys);

    return inventoryData;
  }

  function clearChildren(element) {
    const vehicleResults = document.getElementById('vehicle-results');
    if (vehicleResults) {
      element.removeChild(vehicleResults);
    }
  }

  forEach(getParametersFromUrl(window.location.href), (value, key) => {
    searchParameters[key] = value;
  });

  if (resetButton) {
    resetButton.addEventListener('click', function () {
      window.location = location.origin + location.pathname;
    });
  }

  if (sortBy) {
    sortBy.addEventListener(
      'change',
      debounce((event) => {
        searchParameters.sort = event.target.value;
        getInventory();
      }, 500)
    );
  }

  if (titleSearch) {
    titleSearch.addEventListener(
      'input',
      debounce((event) => {
        searchParameters.title = event.target.value;
        getInventory();
      }, 500)
    );
  }

  function updateFilter(parameter) {
    if (isNumeric(parameter)) {
        searchParameters[`${parameter}_min`] = this.searchParameters[`${parameter}_min`];
        searchParameters[`${parameter}_max`] = this.searchParameters[`${parameter}_max`];

        getInventory();
    } else {
      const paramIndex = drilldown_metadata.indexOf(parameter);

      if (paramIndex >= 0) {
        for (let param of drilldown_metadata) {
          const $el = $(`#${param}`);
          const $select = $el.find('> select');

          if ($select) {
            $select.html(`<option>${inventoryLocalization.gettext('Loading')}...</option>`);
          }
        }
      }

      switch (parameter) {
        case 'category': {
          searchParameters['make'] = null;
          searchParameters['model'] = null;
          break;
        }

        case 'make': {
          searchParameters['model'] = null;
          break;
        }
      }

      getInventory().then((data) => {
        if (searchKeys.indexOf(parameter) >= 0) {
          for (let param of searchKeys) {
            let element = document.getElementById(param);
            if (element) {
              element.innerHTML = '';
              let newFilter = new DSPFilter(element, updateFilter, searchParameters, data);
              newFilter.create();
              setMakesAndModelsLists(newFilter);
            }
          }
        }
      });
    }
  }

  if (isDynamic) {
    updateCallback = updateFilter;
  } else {
    submitButton.addEventListener('click', function () {
      getInventory().then(() => {
        filters.forEach((filterContainer) => {
          updateFilter(filterContainer.id);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    filters.forEach((filterContainer) => {
      const filter = new DSPFilter(
        filterContainer,
        updateCallback,
        searchParameters,
        inventory,
        selected
      );

      filter.create();
      setMakesAndModelsLists(filter);

      if (bnpBanner && ['make', 'model'].includes(filterContainer.id)) {
        filterContainer.addEventListener('dspFilter.change', function () {
          updateBuildAndPriceBanner(bnpBanner);
        });
      }
    });

    // update bnp banner on page load
    if (bnpBanner && (searchParameters['make'] || searchParameters['model'])) {
      updateBuildAndPriceBanner(bnpBanner);
    }
  });
}
